export const TRASH = 'trash';
export const LEGAL = 'legal';
export const NEW = 'new';
export const CASES = 'cases';
